export const YOUTUBE_PLAYER_API = 'https://www.youtube.com/player_api';
export const YOUTUBE_NOCOOKIE_HOST = 'https://www.youtube-nocookie.com';
